module.exports = __webpack_public_path__ + "static/img/gdjt2.4b09b66.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gdjt2.png
// module id = pFqu
// module chunks = 1